import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon, CheckCircleIcon, LockIcon } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-20 md:py-28 bg-beige relative" data-id="element-130">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-olive/30" data-id="element-132">
          {/* Header */}
          <div className="bg-brown-dark text-center py-6 px-4 relative overflow-hidden" data-id="element-133">
            <div className="absolute inset-0 bg-[#2F3D28] opacity-30" data-id="element-134"></div>
            <h2 className="text-2xl md:text-4xl font-bold relative z-10" data-id="element-135">
              <span className="text-gold" data-id="element-136">Empezá hoy</span>{' '}
              <span className="text-olive-light" data-id="element-137">
                con todo el sistema completo
              </span>
            </h2>
          </div>

          <div className="p-8 md:p-12" data-id="element-138">
            {/* Includes list */}
            <h3 className="text-xl font-bold text-brown-dark mb-6 border-b border-beige-dark pb-4" data-id="element-139">
              Incluye:
            </h3>

            <ul className="space-y-4 mb-10" data-id="element-140">
              {['Ebook "Meriendas saludables congeladas"', 'Sistema de costos y precios', 'Estrategia de packs', 'Todos los bonos incluidos'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-141">
                  <svg className="w-6 h-6 text-olive flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-142">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" data-id="element-143"></path>
                  </svg>
                  <span className="text-lg text-brown font-medium" data-id="element-144">{item}</span>
                </li>)}
            </ul>

            {/* Price Block */}
            <div className="bg-beige rounded-2xl p-8 text-center mb-8 border border-beige-dark" data-id="element-145">
              <p className="text-brown/50 line-through text-xl font-medium mb-2" data-id="element-146">
                $39.980
              </p>
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-147">
                <span className="text-5xl md:text-7xl font-bold text-brown-dark tracking-tight" data-id="element-148">
                  $19.990
                </span>
                <span className="text-xs font-bold text-white bg-olive px-3 py-1.5 rounded-full uppercase tracking-wider" data-id="element-149">
                  HOY
                </span>
              </div>
              <p className="text-sm text-brown/60 mt-2" data-id="element-150">
                Precio promocional por lanzamiento
              </p>
            </div>

            {/* Mercado Pago Payment Block */}
            <div className="bg-[#F7F9FC] rounded-2xl p-6 md:p-8 mb-8 border border-[#E0E6ED]" data-id="element-151">
              <div className="flex flex-col sm:flex-row items-center gap-5" data-id="element-152">
                {/* Mercado Pago Logo Space */}
                <div className="flex-shrink-0" data-id="element-153">
                  <img src="https://cdn.magicpatterns.com/uploads/1ixPxNSo5ib2v3P9JPxehK/descarga_(2).png" alt="Mercado Pago" className="h-12 md:h-14 w-auto object-contain" data-id="element-154" />
                </div>

                <div className="text-center sm:text-left flex-1" data-id="element-155">
                  <p className="text-lg md:text-xl font-bold text-brown-dark mb-1" data-id="element-156">
                    Podés pagar con Mercado Pago
                  </p>
                  <div className="flex items-center justify-center sm:justify-start gap-2 text-olive font-semibold" data-id="element-157">
                    <CreditCardIcon className="w-5 h-5" data-id="element-158" />
                    <span data-id="element-159">Hasta 3 cuotas sin interés</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Conversion Reinforcement */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-8" data-id="element-160">
              {[{
              icon: ZapIcon,
              text: 'Acceso inmediato'
            }, {
              icon: CheckCircleIcon,
              text: 'Empezás hoy mismo'
            }, {
              icon: ShieldCheckIcon,
              text: 'Pago 100% seguro'
            }].map((item, index) => <div key={index} className="flex items-center gap-2 text-olive font-semibold" data-id="element-161">
                  <item.icon className="w-5 h-5" data-id="element-162" />
                  <span className="text-sm md:text-base" data-id="element-163">{item.text}</span>
                </div>)}
            </div>

            {/* CTA Button */}
            <motion.a href="https://lacocinaquevende.shop/cart/53476221124881:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-gold hover:bg-gold-hover text-brown-dark font-bold text-xl py-5 px-8 rounded-2xl shadow-[0_4px_20px_rgba(201,169,110,0.4)] transition-all duration-300 flex items-center justify-center gap-3" data-id="element-164">
              👉 COMPRAR AHORA
              <ArrowRightIcon className="w-6 h-6" data-id="element-165" />
            </motion.a>

            {/* Micro Trust */}
            <div className="mt-6 flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6" data-id="element-166">
              <span className="flex items-center gap-2 text-sm text-brown/60 font-medium" data-id="element-167">
                <LockIcon className="w-4 h-4" data-id="element-168" />
                Compra segura
              </span>
              <span className="hidden sm:block w-1 h-1 rounded-full bg-brown/30" data-id="element-169"></span>
              <span className="flex items-center gap-2 text-sm text-brown/60 font-medium" data-id="element-170">
                <CreditCardIcon className="w-4 h-4" data-id="element-171" />
                Múltiples medios de pago
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}